export default function ({commit}, {value}) {
    if (!value) return;
    let i = 0;
    value.forEach(item => {
        commit('column', {name: item.name, field: 'index', value: i});
        i++;
    });
    commit('set',{rebind: false});
    setTimeout(() => {
        commit('set',{rebind: true});
    });
}